// extracted by mini-css-extract-plugin
export default {"container":"niM41GJga4dmzM0gqbbt","titleBlock":"jheXE1Q793uJU0KxjjFO","title":"vKcOhSjNk6nNJSFbRVbn"};